export default [
    {
        path: '/requests',
        name: 'requests',
        component: () => import('@/views/request/index.vue'),
        meta: {
            layout: 'full',
        },
    },
]